import Hero from "@/components/sections/Hero";
import DualPathwayCards from "@/components/sections/DualPathwayCards";
import ApproachPillars from "@/components/sections/ApproachPillars";
import DoctorIntro from "@/components/sections/DoctorIntro";
import Testimonials from "@/components/sections/Testimonials";
import FAQPreview from "@/components/sections/FAQPreview";
import ClosingCTA from "@/components/sections/ClosingCTA";

export default function HomePage() {
    return (
        <>
            <Hero />
            <DualPathwayCards />
            <ApproachPillars />
            <DoctorIntro />
            <Testimonials />
            <FAQPreview limit={4} />
            <ClosingCTA />
        </>
    );
}
